const React = require('react');

module.exports = React.createClass({

	propTypes: {
		size: React.PropTypes.string
	},

	render(){
		var className = 'col';
		var sizes = this.props.size.split(' ');

		sizes.map(function(size){
			className += ' col-'+size;
		});

		if (this.props.className) className += ' ' + this.props.className;

		return (
			<div {...this.props} className={className} >
				{this.props.children}
			</div>
		);
	}
});


/** WEBPACK FOOTER **
 ** ./src/components/col.js
 **/